import React, { useRef, useState, useEffect, useCallback } from "react";
import { RootRouteProps } from "routers/types/stack";

import { useRoute } from "@react-navigation/native";

import { View, Platform } from "react-native";
import { IMessage, GiftedChat } from "react-native-gifted-chat";

import { Text, Button, LoadingBox } from "components";
import ChatDay from "./ChatDay";
import ChatSend from "./ChatSend";
import ChatEmpty from "./ChatEmpty";
import ChatBubble from "./ChatBubble";
import ChatFooter from "./ChatFooter";
import ChatActions from "./ChatActions";
import ChatEarlierLoading from "./ChatEarlierLoading";

import axios from "axios";
import RNBlob, {
  StatefulPromise,
  FetchBlobResponse,
} from "react-native-blob-util";

import { Routes } from "clients/apis/_routes";

import fonts from "assets/fonts";
import { colors, strings } from "assets/constants";

import css from "styles";
import { useFlag } from "hooks";
import { authAtom } from "stores";
import { useRecoilValue } from "recoil";
import { dataUrlToFile } from "utils";

let uploadTask: StatefulPromise<FetchBlobResponse> | null = null;

export default function AttacheInfo() {
  const {
    company: { color },
    token,
  } = useRecoilValue(authAtom);

  const { flg: loading, on: startLoading, off: stopLoading } = useFlag();

  const list = useRef<any>();
  const { data: customer } = useRoute<RootRouteProps<"customerTabs">>().params;

  const [sendingMsg, setSendingMsg] = useState<IMessage>();
  const [messages, setMessages] = useState<Array<IMessage>>([]);
  const [targetMsgID, setTargetMsgID] = useState<number | null>(null);
  const [firstMsgID, setFirstMsgID] = useState<number | null>(null);
  //! ---------------------------------------------------------
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [lastMsgID, setLastMsgID] = useState<number | null>(null);

  const [uploadProgress, setUploadProgress] = useState(0);

  const [replyMsg, setReplyMsg] = useState<IMessage | null>(null);
  const fetchMoreMessages = useCallback(
    (msgID: number | null) => {
      if (msgID && firstMsgID && msgID <= firstMsgID) {
        return;
      }

      const url =
        Routes.BASE_URL + `customer/${customer?.id}/attaches?position=top`;
      const path = msgID ? "&message_id=" + msgID : "";

      axios.get(url + path).then((res) => {
        const data = res?.data;

        const msgs = data.prev_records;

        const targetMsg = msgs?.[msgs?.length - 1];
        setTargetMsgID(targetMsg?.id);

        setLastMsgID(data?.last_record_id);
        setFirstMsgID(data?.first_record_id);

        setMessages((previousMessages) =>
          GiftedChat.append(msgs, previousMessages)
        );
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [customer?.id]
  );

  const _onLoadMore = () => fetchMoreMessages(targetMsgID);

  useEffect(() => {
    fetchMoreMessages(null);
  }, [fetchMoreMessages]);

  const _onSend = useCallback(
    (messagesToSend: IMessage[]) => {
      const url =
        Routes.BASE_URL +
        Routes.ADD_CUSTOMER_ATTACH +
        "/" +
        customer?.id +
        "/attaches";

      const [messageToSend] = messagesToSend;

      messageToSend.pending = true;
      setMessages((previousMessages) =>
        GiftedChat.append(previousMessages, [messageToSend])
      );

      if (Platform.OS === "web" || Platform.OS === "android") {
        const msg = new FormData();
        msg.append("_id", String(messageToSend._id));
        msg.append("text", messageToSend.text);

        if (Platform.OS === "web") {
          const imgFile =
            messageToSend?.image?.includes("data:image") &&
            dataUrlToFile(messageToSend?.image, `profile${Date.now()}`);

          messageToSend.image && msg.append("image", imgFile, imgFile.name);
        } else {
          Platform.OS === "android" &&
            messageToSend.image &&
            msg.append("image", {
              type: messageToSend?.image?.type,
              name: messageToSend?.image?.name,
              uri: messageToSend?.image?.uri,
            } as any);
        }

        axios({
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
          url,
          data: msg,
        }).then((res) => {
          setMessages((previousMessages) =>
            GiftedChat.append(
              previousMessages.map((prevM) => {
                if (prevM._id === messageToSend._id) {
                  if (messageToSend.audio) {
                    return {
                      ...messageToSend,
                      pending: false,
                      received: true,
                    };
                  }
                  return { ...messageToSend, pending: false, received: true };
                } else {
                  return prevM;
                }
              }),
              []
            )
          );
        });

        // axios.post(url, msg).then((res) => {
        //   console.log("------", res);

        // });

        return;
      }

      // const postData = [];
      // postData.push({ name: "_id", data: messageToSend._id });
      // messageToSend.text &&
      //   postData.push({ name: "text", data: messageToSend.text });

      // messageToSend.image &&
      //   postData.push({
      //     name: "image",
      //     filename: messageToSend.image.name,
      //     type: messageToSend.image?.type,
      //     data: RNBlob.wrap(decodeURI(messageToSend.image?.uri)),
      //   });
      // messageToSend.file &&
      //   postData.push({
      //     name: "file",
      //     filename: messageToSend.file.name,
      //     type: messageToSend.file?.type,
      //     data: RNBlob.wrap(decodeURI(messageToSend.file?.uri)),
      //   });
      // messageToSend.audio &&
      //   postData.push({
      //     name: "audio",
      //     filename: messageToSend.audio.name,
      //     type: messageToSend.audio?.type,
      //     data: RNBlob.wrap(messageToSend.audio?.uri),
      //   });

      // if (
      // (messageToSend.file && Number(messageToSend?.file?.size) > 1000000) ||
      // (messageToSend.image && Number(messageToSend?.image?.size) > 1000000) ||
      // (messageToSend.audio && Number(messageToSend?.audio?.size) > 1000000)
      // ) {
      //   startLoading();
      // }

      // setSendingMsg(messageToSend);
      // uploadTask = RNBlob.config({ fileCache: true }).fetch(
      //   "POST",
      //   Routes.BASE_URL +
      //     Routes.ADD_CUSTOMER_ATTACH +
      //     "/" +
      //     customer?.id +
      //     "/attaches",
      //   {
      //     "Content-Type": "multipart/form-data",
      //     Authorization: "Bearer " + token,
      //   },

      //   postData
      // );
      // uploadTask
      //   .uploadProgress((send, total) => {
      //     setUploadProgress(Math.floor((send / total) * 100));
      //   })
      //   .then((res) => {
      //     console.log("res: ", res);

      //     messageToSend.file &&
      //       RNBlob.fs.cp(
      //         decodeURI(messageToSend.file.uri.replace("content:", "file:/")),
      //         decodeURI(
      //           RNBlob.fs.dirs.DownloadDir +
      //             "/" +
      //             messageToSend._id +
      //             "_" +
      //             messageToSend.file.name
      //         )
      //       );

      //     messageToSend.audio &&
      //       RNBlob.fs.cp(
      //         messageToSend.audio.uri,
      //         encodeURI(
      //           RNBlob.fs.dirs.DownloadDir +
      //             "/" +
      //             messageToSend._id +
      //             "_" +
      //             messageToSend.audio.name
      //         )
      //       );

      //     setMessages((previousMessages) =>
      //       GiftedChat.append(
      //         previousMessages.map((prevM) => {
      //           if (prevM._id === messageToSend._id) {
      //             if (messageToSend.audio) {
      //               return {
      //                 ...messageToSend,
      //                 audio: {
      //                   ...messageToSend.audio,
      //                   uri: encodeURI(
      //                     RNBlob.fs.dirs.DownloadDir +
      //                       "/" +
      //                       messageToSend._id +
      //                       "_" +
      //                       messageToSend.audio.name
      //                   ),
      //                 },
      //                 pending: false,
      //                 received: true,
      //               };
      //             }
      //             return { ...messageToSend, pending: false, received: true };
      //           } else {
      //             return prevM;
      //           }
      //         }),
      //         []
      //       )
      //     );

      //     stopLoading();
      //     setUploadProgress(0);
      //   })
      //   .catch(() => {});
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [customer?.id, token]
  );

  const _onCancelSend = async () => {
    stopLoading();
    if (uploadTask) {
      try {
        await uploadTask.cancel(() => {
          setMessages((previousMessages) =>
            GiftedChat.append(
              previousMessages.filter((prevM) => {
                if (sendingMsg && prevM._id !== sendingMsg._id) {
                  return prevM;
                }
              }),
              []
            )
          );
        });
        uploadTask = null;
      } catch (err) {}
    }
  };

  useEffect(() => {}, []);

  return (
    <>
      <GiftedChat
        ref={list}
        infiniteScroll
        alwaysShowSend
        showUserAvatar={false}
        showAvatarForEveryMessage={false}
        placeholder="متن اطلاعات را وارد کنید"
        messages={messages}
        user={{ _id: customer?.id }}
        onSend={_onSend}
        renderSend={(props) => <ChatSend {...props} />}
        renderActions={(props) => <ChatActions onSend={_onSend} {...props} />}
        onLoadEarlier={_onLoadMore}
        loadEarlier={Number(firstMsgID) < Number(targetMsgID) ? true : false}
        renderLoadEarlier={() => <ChatEarlierLoading />}
        renderDay={(props) => <ChatDay {...props} />}
        renderChatEmpty={() => <ChatEmpty />}
        textInputProps={{
          style: {
            flex: 1,
            fontSize: 14,
            textAlign: "right",
            alignSelf: "center",
            paddingHorizontal: 5,
            fontFamily: fonts.fa.default,
            color: colors.textColorDefault,
            marginTop: 0,
            marginBottom: 0,
            paddingBottom: 0,
            ...Platform.select({
              web: {
                outlineColor: colors.transparent,
                height: 55,
                paddingTop: 22,
              },
            }),
          },
        }}
        renderBubble={(props) => (
          <ChatBubble
            {...props}
            onReply={(msg) => {
              setReplyMsg(msg);
              list.current?.textInput.focus();
            }}
          />
        )}
        renderChatFooter={() =>
          replyMsg ? (
            <ChatFooter msg={replyMsg} hide={() => setReplyMsg(null)} />
          ) : null
        }
      />

      {loading && (
        <LoadingBox
          renderContent={() => {
            return (
              <View
                style={{
                  width: 200,
                  height: 200,
                  elevation: 5,
                  borderRadius: 25,
                  ...css.centralElements,
                  paddingVertical: 35,
                  backgroundColor: colors.white,
                }}
              >
                <View
                  style={{
                    width: 170,
                    height: 20,
                    elevation: 1,
                    ...css.overFlowH,
                    borderWidth: 1,
                    borderRadius: 10,
                    borderColor: colors.lightBorder,
                    backgroundColor: colors.white,
                    marginBottom: 10,
                  }}
                >
                  <View
                    style={{
                      ...css.fitHeight,
                      borderWidth: 1,
                      borderRadius: 10,
                      backgroundColor: color,
                      borderColor: colors.white,
                      width: uploadProgress + "%",
                    }}
                  />
                </View>
                <Text weight="bold" color={colors.textColorDark}>
                  {strings.on_sending}
                </Text>

                <View style={css.container} />

                <Button
                  onPress={_onCancelSend}
                  width={120}
                  bgColor={colors.danger}
                  title={{ value: strings.cancel }}
                />
              </View>
            );
          }}
        />
      )}
    </>
  );
}
